import MeetingRoomNoticeBar from "../../components/MeetingRoom/Notice/MeetingRoomNoticeBar";
import MeetingRoomContent from "../../components/MeetingRoom/MeetingRoomContent";
import { Grid } from "@mui/material";
import {
  GridContainerStyle,
  PageContainer,
} from "../../components/Common/Container/ContainerStyled";
import { useDeviceType } from "../../hooks/useDeviceType";
import { MeetingRoomContentWrapper } from "./MeetingRoomMainPageStyled";

const MeetingRoomMainPage = () => {
  const deviceType = useDeviceType();

  return (
    <PageContainer>
      <Grid sx={GridContainerStyle(deviceType)}>
        <MeetingRoomContentWrapper>
          <MeetingRoomNoticeBar />
          <MeetingRoomContent />
        </MeetingRoomContentWrapper>
      </Grid>
    </PageContainer>
  );
};

export default MeetingRoomMainPage;
